export const initialProductInfo = {
  image: "",
  federationUrl: "",
  logoUrl: "",
  supportEmail: "",
  description: "",
  productLandingPageURL: "",
  isPublished: true
}

export const initialExternalProductInfo: App.ExternalProductInfo = {
  authKey: "",
  authMethod: "",
  docLink: "",
  externalApiUrl: "",
  docTitle: "",
  docDescription: ""
}

export const authMethodSelectOptions = [{ value: "ApiKey", label: "Chave API" }]

export const initialProductFilesObj: App.ProductFilesObj = {}

export const initialBannerInfoForm: App.BannerInfoForm = {
  imageFile: undefined,
  hex: "#002C98",
  hexSecondary: "#6729EA",
  isGradient: false
}

export const initialBannerInfo: App.BannerInfo = {
  bannerImageUrl: "",
  color: "#002C98",
  colorSecondary: "#6729EA",
  isGradient: false
}

export const initialMarketplaceInfo: App.MarketplaceInfo = {
  benefits: [],
  bannerInfo: initialBannerInfo
}

export const removeNonHexCharacters = /[^0-9a-fA-F]/g

export const LIMIT_BENEFITS_CHARACTERS = 100
